export const environment = {
  production: true,
  appVersion: "v717demo1",
  USERDATA_KEY: "authf649fc9a5f55",
  isMockEnabled: true,
  //apiUrl: "http://workflowbackend/api",
  //qformUrl: "http://backend",

  baseUrl: "https://demoflow.qforms.co",
  apiUrl: "https://demoflowapi.qforms.co/api",
  qformUrl: "https://demoapi.qforms.co",
  qformFrontEndUrl: "https://demo.qforms.co",
  INTEGRATION_HUB_FRONTEND_URL: "https://demoihub.qforms.co",
  INTEGRATION_HUB_BACKEND_URL: "https://demoihubapi.qforms.co",

  // baseUrl: "https://devwflow.qforms.co",
  // apiUrl: "https://devwflowapi.qforms.co/api",
  // qformUrl: "https://devapi.qforms.co",
  // qformFrontEndUrl: "https://dev.qforms.co",
  // INTEGRATION_HUB_FRONTEND_URL: "https://devihub.qforms.co",
  // INTEGRATION_HUB_BACKEND_URL: "https://devihubapi.qforms.co",

  servicenow_instanceid: "dev114543",
  servicenow_tablename: "u_mudasir_table_label",
};
export class Config {
  static DATE_FMT = "dd-MM-yyyy";
  static DATE_TIME_FMT = `${Config.DATE_FMT} hh:mma`;
  static secretKey = "drQ8pzjLMqEKZyAhyLqXlxZdyQTsEoiq";
}
